import {Component, EventEmitter, input, Input, OnInit, Output} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ChartConstants} from '@constants/pages/chart-constants';

@Component({
    selector: 'scitis-widget-time-period-input',
    templateUrl: './widget-time-period-input.component.html',
    styleUrls: ['./widget-time-period-input.component.scss'],
    standalone: false
})
export class WidgetTimePeriodInputComponent implements OnInit {

  @Input()
  timePeriod: number = 5;

  disabled = input(false);

  @Output()
  timePeriodChanged: EventEmitter<number> = new EventEmitter<number>();

  public isInvalidValue: boolean = false;
  public warningMessage: string;
  public MIN_INTERVAL_MINUTES = 1;
  public MAX_INTERVAL_MINUTES = ChartConstants.MAX_INTERVAL_MINUTES;

  constructor(private translate: TranslateService) {
    this.warningMessage = translate.instant('Time period has to be and integer value between %min and %max minutes.')
    .replace('%min', this.MIN_INTERVAL_MINUTES)
    .replace('%max', this.MAX_INTERVAL_MINUTES);
  }

  onTimePeriodChange() {
    this.validatePeriod();
    this.timePeriodChanged.emit(this.timePeriod);
  }

  ngOnInit(): void {
    this.validatePeriod();
  }

  private validatePeriod() {
    if (this.timePeriod < this.MIN_INTERVAL_MINUTES) {
      this.isInvalidValue = true;
      return;
    }

    if (this.timePeriod > this.MAX_INTERVAL_MINUTES) {
      this.isInvalidValue = true;
      return;
    }

    if (!Number.isInteger(this.timePeriod)) {
      this.isInvalidValue = true;
      return;
    }

    this.isInvalidValue = false;
  }
}
